import {Injectable} from '@angular/core';

declare const window: any;
declare const FB: any;

@Injectable({
  providedIn: 'root'
})
export class FacebookService {
  loadSdk(): void {
    // Replace YOUR_APP_ID with your Facebook App ID
    (window as any).fbAsyncInit = function () {
      FB.init({
        appId: '376852941444713',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v10.0'
      });
    };

    // Load the SDK asynchronously
    (function (d, s, id) {
      let js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  reinitializeLikeButton(): void {
    console.log('reinitializeLikeButton');
    // Call FB.XFBML.parse() to re-parse and render XFBML elements
    setTimeout(() => {
      FB.XFBML.parse();
    },500);
  }
}
